
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/orders",
      function () {
        return require("private-next-pages/shop/orders/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/orders"])
      });
    }
  